export enum EUtilityOptionType {
  SHOWER = "SHOWER",
  BATHTUB_JACUZZI = "BATHTUB_JACUZZI",
}
